import { apiCall } from './gqlClient';

const LOGIN_QUERY = `
  query login($email: String!, $password: String!, $appName: String, $appVersion: String, $appOs: String) {
    login(email: $email, password: $password, appName: $appName, appVersion: $appVersion, appOs: $appOs)
    {
      success
			accessToken
			expirationTimestamp
			refreshToken
			userId
			userRole
			errorCode
      ...fragments
    }
  }`;

export const loginApiCall = async ({email, password, appName, appVersion, appOs}, fragments = null) => apiCall({ query: LOGIN_QUERY, variables: {email, password, appName, appVersion, appOs}, fragments });

const REFRESHTOKEN_QUERY = `
  query refreshToken($refToken: String!, $providerId: Int, $appVersion: String, $appName: String) {
    refreshToken(refToken: $refToken, providerId: $providerId, appVersion: $appVersion, appName: $appName)
    {
      success
			accessToken
			expirationTimestamp
			refreshToken
			userId
			userRole
			errorCode
      ...fragments
    }
  }`;

export const refreshTokenApiCall = async ({refToken, providerId, appVersion, appName}, fragments = null) => apiCall({ query: REFRESHTOKEN_QUERY, variables: {refToken, providerId, appVersion, appName}, fragments });

const GETCURRENTUSER_QUERY = `
  query getCurrentUser {
    getCurrentUser
    {
      id
			resourceId
			ownerId
			ownerIds
			name
			firstname
			lastname
			fullname
			gender
			birthday
			address
			city
			postcode
			country
			tags
			url
			facebook
			phone
			email
			role
			code
			codeExpiration
			active
			image
			status
			providerId
			providersIds
			userLanguage
			blacklisted
			blockContent
			describedName
			note
			codiceFiscale
			piva
			sdi
			created
			ordersNumber
			customerId
			svcGroupId
			groupColor
			completedOnboarding
			timezone
			nextEventAt
			nextEventName
			membershipActive
			membershipExpiresAt
      ...fragments
    }
  }`;

export const getCurrentUserApiCall = async (fragments = null) => apiCall({ query: GETCURRENTUSER_QUERY, variables: {}, fragments });

const LISTALLUSERS_QUERY = `
  query listAllUsers {
    listAllUsers
    {
      id
			resourceId
			ownerId
			ownerIds
			name
			firstname
			lastname
			fullname
			gender
			birthday
			address
			city
			postcode
			country
			tags
			url
			facebook
			phone
			email
			role
			code
			codeExpiration
			active
			image
			status
			providerId
			providersIds
			userLanguage
			blacklisted
			blockContent
			describedName
			note
			codiceFiscale
			piva
			sdi
			created
			ordersNumber
			customerId
			svcGroupId
			groupColor
			completedOnboarding
			timezone
			nextEventAt
			nextEventName
			membershipActive
			membershipExpiresAt
      ...fragments
    }
  }`;

export const listAllUsersApiCall = async (fragments = null) => apiCall({ query: LISTALLUSERS_QUERY, variables: {}, fragments });

const GETMYAFFILIATEDUSERS_QUERY = `
  query getMyAffiliatedUsers {
    getMyAffiliatedUsers
  }`;

export const getMyAffiliatedUsersApiCall = async () => apiCall({ query: GETMYAFFILIATEDUSERS_QUERY, variables: {}});

const GETOWNERPROVIDERS_QUERY = `
  query getOwnerProviders {
    getOwnerProviders
    {
      id
			cityId
			name
			type
			description
			address
			postcode
			country
			phone
			latitude
			longitude
			acceptPayments
			onlineDiscount
			time
			timeNote
			tags
			url
			blog
			facebook
			twitter
			linkedin
			skype
			instagram
			youtube
			email
			role
			created
			active
			subscribed
			userHasMembership
			membershipsCounter
			freeCancellationHours
			reservationOffset
			hasConnectedPaymentAccount
			defaultTimeSlotStep
			language
			ownerId
			locked
			free
			ordersNumber
			notificationEmail
			appName
			clientProvider
			timezone
			canUnlock
			joinPolicy
			approvalMethod
      ...fragments
    }
  }`;

export const getOwnerProvidersApiCall = async (fragments = null) => apiCall({ query: GETOWNERPROVIDERS_QUERY, variables: {}, fragments });

const VALIDATEAPPVERSION_QUERY = `
  query validateAppVersion($version: String!) {
    validateAppVersion(version: $version)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const validateAppVersionApiCall = async ({version}, fragments = null) => apiCall({ query: VALIDATEAPPVERSION_QUERY, variables: {version}, fragments });

const GETALLFREEUSERS_QUERY = `
  query getAllFreeUsers {
    getAllFreeUsers
    {
      id
			resourceId
			ownerId
			ownerIds
			name
			firstname
			lastname
			fullname
			gender
			birthday
			address
			city
			postcode
			country
			tags
			url
			facebook
			phone
			email
			role
			code
			codeExpiration
			active
			image
			status
			providerId
			providersIds
			userLanguage
			blacklisted
			blockContent
			describedName
			note
			codiceFiscale
			piva
			sdi
			created
			ordersNumber
			customerId
			svcGroupId
			groupColor
			completedOnboarding
			timezone
			nextEventAt
			nextEventName
			membershipActive
			membershipExpiresAt
      ...fragments
    }
  }`;

export const getAllFreeUsersApiCall = async (fragments = null) => apiCall({ query: GETALLFREEUSERS_QUERY, variables: {}, fragments });

const GETALLUSERS_QUERY = `
  query getAllUsers {
    getAllUsers
    {
      id
			name
			phone
			email
			role
			active
			image
			codiceFiscale
			piva
			sdi
			created
      ...fragments
    }
  }`;

export const getAllUsersApiCall = async (fragments = null) => apiCall({ query: GETALLUSERS_QUERY, variables: {}, fragments });

const GETTOP100MOSTACTIVEUSERS_QUERY = `
  query getTop100MostActiveUsers($startDate: DateTime!, $endDate: DateTime!) {
    getTop100MostActiveUsers(startDate: $startDate, endDate: $endDate)
    {
      id
			resourceId
			ownerId
			ownerIds
			name
			firstname
			lastname
			fullname
			gender
			birthday
			address
			city
			postcode
			country
			tags
			url
			facebook
			phone
			email
			role
			code
			codeExpiration
			active
			image
			status
			providerId
			providersIds
			userLanguage
			blacklisted
			blockContent
			describedName
			note
			codiceFiscale
			piva
			sdi
			created
			ordersNumber
			customerId
			svcGroupId
			groupColor
			completedOnboarding
			timezone
			nextEventAt
			nextEventName
			membershipActive
			membershipExpiresAt
      ...fragments
    }
  }`;

export const getTop100MostActiveUsersApiCall = async ({startDate, endDate}, fragments = null) => apiCall({ query: GETTOP100MOSTACTIVEUSERS_QUERY, variables: {startDate, endDate}, fragments });

const GETUSERSFORDELETE_QUERY = `
  query getUsersForDelete {
    getUsersForDelete
  }`;

export const getUsersForDeleteApiCall = async () => apiCall({ query: GETUSERSFORDELETE_QUERY, variables: {}});

const SETDEFAULTUSERPASSWORD_QUERY = `
  query setDefaultUserPassword($email: String!) {
    setDefaultUserPassword(email: $email)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const setDefaultUserPasswordApiCall = async ({email}, fragments = null) => apiCall({ query: SETDEFAULTUSERPASSWORD_QUERY, variables: {email}, fragments });

const GETCOGNITOUSERDATA_QUERY = `
  query getCognitoUserData($email: String!) {
    getCognitoUserData(email: $email)
  }`;

export const getCognitoUserDataApiCall = async ({email}, ) => apiCall({ query: GETCOGNITOUSERDATA_QUERY, variables: {email}});

const RESETUSERCOGNITOPASSWORD_QUERY = `
  query resetUserCognitoPassword($email: String!) {
    resetUserCognitoPassword(email: $email)
  }`;

export const resetUserCognitoPasswordApiCall = async ({email}, ) => apiCall({ query: RESETUSERCOGNITOPASSWORD_QUERY, variables: {email}});

const CONFIRMUSER_QUERY = `
  mutation confirmUser($id: Int!) {
    confirmUser(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const confirmUserApiCall = async ({id}, fragments = null) => apiCall({ query: CONFIRMUSER_QUERY, variables: {id}, fragments });

const UPDATEUSERPROFILE_QUERY = `
  mutation updateUserProfile($request: UserInput!) {
    updateUserProfile(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateUserProfileApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATEUSERPROFILE_QUERY, variables: {request}, fragments });

const CHANGEUSERAVATAR_QUERY = `
  mutation changeUserAvatar($fileType: String!) {
    changeUserAvatar(fileType: $fileType)
    {
      id
			presignedUrl
			signedUrl
			success
			name
			sectionIndex
      ...fragments
    }
  }`;

export const changeUserAvatarApiCall = async ({fileType}, fragments = null) => apiCall({ query: CHANGEUSERAVATAR_QUERY, variables: {fileType}, fragments });

const TOGGLEUSERSTATUS_QUERY = `
  mutation toggleUserStatus($id: Int!, $status: Boolean!) {
    toggleUserStatus(id: $id, status: $status)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const toggleUserStatusApiCall = async ({id, status}, fragments = null) => apiCall({ query: TOGGLEUSERSTATUS_QUERY, variables: {id, status}, fragments });

const ASSIGNUSER_QUERY = `
  mutation assignUser($id: Int!, $providerId: Int!, $resourceId: Int, $role: String) {
    assignUser(id: $id, providerId: $providerId, resourceId: $resourceId, role: $role)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const assignUserApiCall = async ({id, providerId, resourceId, role}, fragments = null) => apiCall({ query: ASSIGNUSER_QUERY, variables: {id, providerId, resourceId, role}, fragments });

const INVITEUSER_QUERY = `
  mutation inviteUser($email: String!, $firstName: String!, $lastName: String!, $role: String!) {
    inviteUser(email: $email, firstName: $firstName, lastName: $lastName, role: $role)
    {
      id
			resourceId
			ownerId
			ownerIds
			name
			firstname
			lastname
			fullname
			gender
			birthday
			address
			city
			postcode
			country
			tags
			url
			facebook
			phone
			email
			role
			code
			codeExpiration
			active
			image
			status
			providerId
			providersIds
			userLanguage
			blacklisted
			blockContent
			describedName
			note
			codiceFiscale
			piva
			sdi
			created
			ordersNumber
			customerId
			svcGroupId
			groupColor
			completedOnboarding
			timezone
			nextEventAt
			nextEventName
			membershipActive
			membershipExpiresAt
      ...fragments
    }
  }`;

export const inviteUserApiCall = async ({email, firstName, lastName, role}, fragments = null) => apiCall({ query: INVITEUSER_QUERY, variables: {email, firstName, lastName, role}, fragments });

const INVITEANDCREATECOLLABORATOR_QUERY = `
  mutation inviteAndCreateCollaborator($email: String!, $firstName: String!, $lastName: String!, $role: String!, $resourceId: Int) {
    inviteAndCreateCollaborator(email: $email, firstName: $firstName, lastName: $lastName, role: $role, resourceId: $resourceId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const inviteAndCreateCollaboratorApiCall = async ({email, firstName, lastName, role, resourceId}, fragments = null) => apiCall({ query: INVITEANDCREATECOLLABORATOR_QUERY, variables: {email, firstName, lastName, role, resourceId}, fragments });

const VERIFYCOGNITOEMAIL_QUERY = `
  mutation verifyCognitoEmail($email: String!, $code: String!) {
    verifyCognitoEmail(email: $email, code: $code)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const verifyCognitoEmailApiCall = async ({email, code}, fragments = null) => apiCall({ query: VERIFYCOGNITOEMAIL_QUERY, variables: {email, code}, fragments });

const RESENDVERIFICATIONEMAIL_QUERY = `
  mutation resendVerificationEmail($clientId: String!) {
    resendVerificationEmail(clientId: $clientId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const resendVerificationEmailApiCall = async ({clientId}, fragments = null) => apiCall({ query: RESENDVERIFICATIONEMAIL_QUERY, variables: {clientId}, fragments });

const CREATEUSER_QUERY = `
  mutation createUser($email: String!, $agreements: [AgreementInput]!, $role: String!, $firstName: String, $lastName: String, $password: String, $clientId: String) {
    createUser(email: $email, agreements: $agreements, role: $role, firstName: $firstName, lastName: $lastName, password: $password, clientId: $clientId)
    {
      id
			resourceId
			ownerId
			ownerIds
			name
			firstname
			lastname
			fullname
			gender
			birthday
			address
			city
			postcode
			country
			tags
			url
			facebook
			phone
			email
			role
			code
			codeExpiration
			active
			image
			status
			providerId
			providersIds
			userLanguage
			blacklisted
			blockContent
			describedName
			note
			codiceFiscale
			piva
			sdi
			created
			ordersNumber
			customerId
			svcGroupId
			groupColor
			completedOnboarding
			timezone
			nextEventAt
			nextEventName
			membershipActive
			membershipExpiresAt
      ...fragments
    }
  }`;

export const createUserApiCall = async ({email, agreements, role, firstName, lastName, password, clientId}, fragments = null) => apiCall({ query: CREATEUSER_QUERY, variables: {email, agreements, role, firstName, lastName, password, clientId}, fragments });

const CREATEUSERANDPROVIDER_QUERY = `
  mutation createUserAndProvider($email: String!, $providerName: String!, $providerType: String!, $category: Int!, $agreements: [AgreementInput]!, $role: String!, $password: String, $clientId: String, $timezone: String, $tags: String, $phone: String) {
    createUserAndProvider(email: $email, providerName: $providerName, providerType: $providerType, category: $category, agreements: $agreements, role: $role, password: $password, clientId: $clientId, timezone: $timezone, tags: $tags, phone: $phone)
    {
      id
			resourceId
			ownerId
			ownerIds
			name
			firstname
			lastname
			fullname
			gender
			birthday
			address
			city
			postcode
			country
			tags
			url
			facebook
			phone
			email
			role
			code
			codeExpiration
			active
			image
			status
			providerId
			providersIds
			userLanguage
			blacklisted
			blockContent
			describedName
			note
			codiceFiscale
			piva
			sdi
			created
			ordersNumber
			customerId
			svcGroupId
			groupColor
			completedOnboarding
			timezone
			nextEventAt
			nextEventName
			membershipActive
			membershipExpiresAt
      ...fragments
    }
  }`;

export const createUserAndProviderApiCall = async ({email, providerName, providerType, category, agreements, role, password, clientId, timezone, tags, phone}, fragments = null) => apiCall({ query: CREATEUSERANDPROVIDER_QUERY, variables: {email, providerName, providerType, category, agreements, role, password, clientId, timezone, tags, phone}, fragments });

const INVITEAFFILIATEUSER_QUERY = `
  mutation inviteAffiliateUser($email: String!) {
    inviteAffiliateUser(email: $email)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const inviteAffiliateUserApiCall = async ({email}, fragments = null) => apiCall({ query: INVITEAFFILIATEUSER_QUERY, variables: {email}, fragments });

const RESIGNUP_QUERY = `
  mutation reSignUp($email: String!) {
    reSignUp(email: $email)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const reSignUpApiCall = async ({email}, fragments = null) => apiCall({ query: RESIGNUP_QUERY, variables: {email}, fragments });

const UPDATEUSERLOGIN_QUERY = `
  mutation updateUserLogin($providerId: Int!) {
    updateUserLogin(providerId: $providerId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateUserLoginApiCall = async ({providerId}, fragments = null) => apiCall({ query: UPDATEUSERLOGIN_QUERY, variables: {providerId}, fragments });

const EXITPROVIDERCONTEXT_QUERY = `
  mutation exitProviderContext {
    exitProviderContext
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const exitProviderContextApiCall = async (fragments = null) => apiCall({ query: EXITPROVIDERCONTEXT_QUERY, variables: {}, fragments });

const DEACTIVATEUSERACCOUNT_QUERY = `
  mutation deactivateUserAccount($forDelete: Boolean) {
    deactivateUserAccount(forDelete: $forDelete)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const deactivateUserAccountApiCall = async ({forDelete}, fragments = null) => apiCall({ query: DEACTIVATEUSERACCOUNT_QUERY, variables: {forDelete}, fragments });

const REQUESTREACTIVATEUSERACCOUNT_QUERY = `
  mutation requestReactivateUserAccount($email: String!) {
    requestReactivateUserAccount(email: $email)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const requestReactivateUserAccountApiCall = async ({email}, fragments = null) => apiCall({ query: REQUESTREACTIVATEUSERACCOUNT_QUERY, variables: {email}, fragments });

const REACTIVATEUSERACCOUNT_QUERY = `
  mutation reactivateUserAccount($email: String!, $code: String!) {
    reactivateUserAccount(email: $email, code: $code)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const reactivateUserAccountApiCall = async ({email, code}, fragments = null) => apiCall({ query: REACTIVATEUSERACCOUNT_QUERY, variables: {email, code}, fragments });

const SAVEUSERREGION_QUERY = `
  mutation saveUserRegion($region: String!) {
    saveUserRegion(region: $region)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const saveUserRegionApiCall = async ({region}, fragments = null) => apiCall({ query: SAVEUSERREGION_QUERY, variables: {region}, fragments });

const EDITUSERBYADMIN_QUERY = `
  mutation editUserByAdmin($request: UserInput!) {
    editUserByAdmin(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const editUserByAdminApiCall = async ({request}, fragments = null) => apiCall({ query: EDITUSERBYADMIN_QUERY, variables: {request}, fragments });

const TOGGLEUSERSTATUSBYADMIN_QUERY = `
  mutation toggleUserStatusByAdmin($id: Int!, $status: Boolean!) {
    toggleUserStatusByAdmin(id: $id, status: $status)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const toggleUserStatusByAdminApiCall = async ({id, status}, fragments = null) => apiCall({ query: TOGGLEUSERSTATUSBYADMIN_QUERY, variables: {id, status}, fragments });

const REMOVEUSERFROMGROUP_QUERY = `
  mutation removeUserFromGroup($groupId: Int!, $providerId: Int!) {
    removeUserFromGroup(groupId: $groupId, providerId: $providerId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const removeUserFromGroupApiCall = async ({groupId, providerId}, fragments = null) => apiCall({ query: REMOVEUSERFROMGROUP_QUERY, variables: {groupId, providerId}, fragments });

const SETCOGNITOEMAILVERIFIEDBYADMIN_QUERY = `
  mutation setCognitoEmailVerifiedByAdmin($email: String!) {
    setCognitoEmailVerifiedByAdmin(email: $email)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const setCognitoEmailVerifiedByAdminApiCall = async ({email}, fragments = null) => apiCall({ query: SETCOGNITOEMAILVERIFIEDBYADMIN_QUERY, variables: {email}, fragments });

const CREATEUSERNOTIFICATIONENDPOINT_QUERY = `
  mutation createUserNotificationEndpoint($token: String) {
    createUserNotificationEndpoint(token: $token)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const createUserNotificationEndpointApiCall = async ({token}, fragments = null) => apiCall({ query: CREATEUSERNOTIFICATIONENDPOINT_QUERY, variables: {token}, fragments });

const ADDFRANCESCOASDIRECTORTOPROVIDER_QUERY = `
  mutation addFrancescoAsDirectorToProvider($id: Int) {
    addFrancescoAsDirectorToProvider(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const addFrancescoAsDirectorToProviderApiCall = async ({id}, fragments = null) => apiCall({ query: ADDFRANCESCOASDIRECTORTOPROVIDER_QUERY, variables: {id}, fragments });
